import { useState } from 'react';
import { TableColumn } from 'react-data-table-component';
import { Badge, Input, Label } from 'reactstrap';

import { ApiKey } from '../../models';

const PERMISSION_LABELS: Record<string, string> = {
  read: 'Leitura',
  write: 'Escrita',
};

const CopyTokenCell = ({ token }: { token: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(token).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    });
  };

  return (
    <div className="d-flex align-items-center gap-2 py-2">
      <code
        style={{
          background: '#f1f3f5',
          padding: '2px 8px',
          borderRadius: 4,
          fontSize: 12,
        }}
      >
        {token}
      </code>
      <button
        type="button"
        className={`btn btn-sm ${copied ? 'btn-success' : 'btn-outline-primary'}`}
        onClick={handleCopy}
        style={{ minWidth: 96 }}
      >
        <i
          className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'} me-1`}
        />
        {copied ? 'Copiado!' : 'Copiar'}
      </button>
    </div>
  );
};

export const makeColumnsApiKeys = (
  onToggleActive: (row: ApiKey) => void,
  togglingId: string | null = null,
): TableColumn<ApiKey>[] => [
  {
    name: 'Nome do app',
    sortable: true,
    selector: (row) => row.appName,
    grow: 2,
    cell: (row) => <strong>{row.appName}</strong>,
  },
  {
    name: 'Token',
    grow: 3,
    wrap: true,
    cell: (row) => <CopyTokenCell token={row.id} />,
  },
  {
    name: 'Permissões',
    grow: 1,
    cell: (row) => (
      <div className="d-flex flex-wrap gap-1 py-2">
        {row.permissions.map((permission) => (
          <Badge key={permission} color="info" pill>
            {PERMISSION_LABELS[permission] ?? permission}
          </Badge>
        ))}
      </div>
    ),
  },
  {
    name: 'Status',
    sortable: true,
    selector: (row) => (row.active ? 'Ativo' : 'Inativo'),
    width: '140px',
    cell: (row) => (
      <div className="form-check form-switch form-switch-success mb-0">
        <Input
          className="form-check-input"
          type="checkbox"
          role="switch"
          id={`api-key-active-${row.id}`}
          checked={row.active}
          disabled={togglingId === row.id}
          onChange={() => onToggleActive(row)}
        />
        <Label
          className="form-check-label"
          htmlFor={`api-key-active-${row.id}`}
        >
          {row.active ? 'Ativo' : 'Inativo'}
        </Label>
      </div>
    ),
  },
];
